var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _circle, _path3, _circle2, _ellipse, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpApproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3254 24.0985L70.3552 34.9382V74.0596L20.0985 74.5523V34.9382L45.3254 24.0985Z",
    fill: "#55B3D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3388 36.3866L48.1831 25.496L44.9426 24.1971L20 34.688V74.4537H23.3388V36.3866Z",
    fill: "#2EA0C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 31.2921,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 34.4455,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 37.4018,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1388,
    y: 42.526,
    width: 43.1616,
    height: 21.4823,
    fill: "#548CAF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.621,
    y: 49.2272,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8035,
    y: 56.1251,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7452,
    y: 49.2272,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.621,
    y: 49.2272,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0513,
    y: 49.2272,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2338,
    y: 56.1251,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1755,
    y: 49.2272,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0513,
    y: 49.2272,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3143,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4968,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4385,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3143,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3359,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5184,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4601,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3359,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8986,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.0812,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0229,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8986,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.334,
    cy: 60.436,
    r: 15.1509,
    fill: "#C1EAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5942 66.4964V72.1239C62.1436 78.8336 71.7031 74.3605 74.2643 70.9335V66.4964C73.4851 63.5528 69.8273 62.2398 68.0958 61.9512H58.7888C54.8063 62.0378 53.6664 65.0174 53.5942 66.4964Z",
    fill: "#F26A58"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.108,
    cy: 57.4072,
    r: 5.76945,
    fill: "#575E69"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.3986,
    cy: 68.5526,
    rx: 6.60145,
    ry: 6.60145,
    fill: "#8DCD35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9203 68.3201L71.9295 70.6316L76.6592 66.6047",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpApproval);
export default __webpack_public_path__ + "static/media/cp_approval.c69aecd19314f41640399fe86c2badf5.svg";
export { ForwardRef as ReactComponent };